export default __webpack_public_path__ + "static/media/ALLERGEN_SESAME.382da328.png";